export const ALGORITHMS = [
  {
    key: 'CIE76',
    value: 'CIE76'
  }
]

export const SIZE = {
  '64x64': [64, 64],
  '64x96': [64, 96],
  '96x64': [96, 64]
}

export const DEFAULT_COLORS = [{
  name: '黄色',
  value: '#d5c520'
}, {
  name: '蓝灰',
  value: '#98b0cc'
}, {
  name: '千岁绿',
  value: '#1d6c4e'
}, {
  name: '练色',
  value: '#d5c4a1'
}, {
  name: '丁香色',
  value: '#c0a0e0'
}, {
  name: '黑色',
  value: '#000000'
}, {
  name: '白色',
  value: '#f0f0f0'
}, {
  name: '枯茶',
  value: '#513127'
}, {
  name: '银灰',
  value: '#56595c'
}, {
  name: '浅蓝',
  value: '#7c98ae'
}, {
  name: '草绿',
  value: '#84be3d'
}, {
  name: '真红',
  value: '#920a09'
}, {
  name: '品红',
  value: '#c40098'
}, {
  name: '淡灰',
  value: '#a4a9a7'
}, {
  name: '淡棕色',
  value: '#745e41'
}, {
  name: '浅棕色',
  value: '#8d6d41'
}, {
  name: '虾黄',
  value: '#ba8f5e'
}, {
  name: '浅澄',
  value: '#fb9966'
}, {
  name: '橙色',
  value: '#ea8b5d'
}, {
  name: '蓝色',
  value: '#355db5'
}, {
  name: '紫蓝色',
  value: '#150057'
}, {
  name: '紫色',
  value: '#4b215d'
}, {
  name: '浅绿',
  value: '#4ea7b5'
}, {
  name: '墨绿',
  value: '#1d4942'
}]
